export const AppConstants = {
    NAME_REGEX: /^([a-zA-Za-åa-ö-w-я ]+ )+[a-zA-Za-åa-ö-w-я ]+$|^[a-zA-Za-åa-ö-w-я ]*$/,
    NUMARIC_ONLY_REGEX: /^[0-9]+$/,
    CITY_REGEX: /^[a-zA-Z ]*$/,
    ADDRESS_LINE_LENGTH: 500,

    timeStampFiltered: [
        "CreatedTimeStamp",
        "SubmissionTimeStamp",
        "ReviewStartedTimeStamp",
        "ReviewCompletedTimeStamp",
        "MadeOn",
        "ActionTimeStamp",
        "FileTimeStamp",
        "TransactionTimestamp",
        "TimeStampTo"
    ],
    AmountValidRegex: /^\d+(\.\d{1,2})?$/,
    AmountChangeRegex: /^[1-9]\d*(\.\d{0,2})?$/,
    TitleRegex: /^(?=[a-zA-Z].*[a-zA-Z])[-0-9a-zA-Z\s,.#]+(?<!\s{2,})$/,
    MessageRegex: /^(?=[a-zA-Z].*[a-zA-Z])[-0-9a-zA-Z\s,.#]+(?<!\s{2,})$/,
    ScaOtpRegex: /^[0-9]{0,6}$/,
    InstitutionNameLength: 100,
    NameLength: 128,
    AmountMax: 1000000,
    NotesAndReasonLength: 200,
    IbanMaxLength: 40,
    IbanMinLength: 16,
    IbanNumberRegex: /^[a-zA-Z0-9]{10,}$/,
    emojiRegex: /([\u{1F600}-\u{1F64F}]|[\u{1F300}-\u{1F5FF}]|[\u{1F680}-\u{1F6FF}]|[\u{1F700}-\u{1F77F}]|[\u{1F780}-\u{1F7FF}]|[\u{1F800}-\u{1F8FF}]|[\u{1F900}-\u{1F9FF}]|[\u{1FA00}-\u{1FA6F}]|[\u{1FA70}-\u{1FAFF}]|[\u{2600}-\u{26FF}]|[\u{2700}-\u{27BF}]|[\u{1F1E6}-\u{1F1FF}])/gu,
    True: "True",
    False: "False",
    AllowMultiMerchantIban: "AllowMultiMerchantIban",
    AllowMultiMerchantClientIban: "AllowMultiMerchantClientIban",
    IsKycOptional: "IsKycOptional",
    IsBillTariffActive: "IsBillTariffActive",
    IsCardIssuer: "IsCardIssuer",
    // Whitelist file upload constants
    WhitelistFileSizeLimit: 10 * 1024 * 1024, // 10 MB
    WhitelistAllowedFileTypes: ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
    WhitelistAllowedFileExtensions: ['.pdf', '.doc', '.docx'],
    WhitelistToastLife: 3000,
    // Bill Tariff Constants
    ScaleTierMaxValue: 1000000,
    ScaleTierMaxTariffAmount: 20,
    FixedTariffMaxValue: 1000,
};

export const MerchantError = {
    HasMissingData: "Merchant has missing data",
};

export const Roles = {
    SUPER_ADMIN: "Super Admin",
    TennAdmin: "10n Admin",
    ComplianceOfficer: "Compliance Officer",
    ComplianceOfficerApprover: "Compliance Officer Approver",
    MerchantMaster: "Merchant Master",
    MerchantLeads: "Merchant Leads",
    MerchantTechnicalAccount: "Merchant Technical Account",
    MassPaymentExecutor: "Mass Payment Executor",
    OperationOfficer: "Operation Officer",
    UserDataManager:"User Data Manager",
    SoftDeleteUser:"User Soft Delete Manager",
    NotificationsManager: "Notifications Manager"
};

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const NAME_REGEX = /^(?!.*--)(?!^-)(?!.*-$)(?!.*[ ]-|.*-[ ])[\p{L}-]+(?: [\p{L}-]+)*$/u;
export const PASSWORD_REGEX = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z])[^ ]{8,}$/;
export const Amount_Valid_REGEX = /^\d+(\.\d{1,2})?$/;
export const Personal_Id_REGEX = /^\d{10}$/;
export const National_Id_REGEX = /^\d{9}$/;
export const Only_Digit_REGEX = /^\d*$/;
export const NON_DIGIT_REPLACEMENT_REGEX = /\D/g;
export const Max_Amount = 1000000;
export const Transaction_Charge = 1;
export const Withdraw_Max_Amount = 100000;
export const Notes_And_Reason_Length = 200;
export const Profile_picture_width = 400;
export const Profile_picture_height = 400;
export const Account_Number_Length = 8;
export const TRX_ID_MIN_Length = 13;
export const TRX_ID_MAX_Length = 16;
export const Image_File_Size = 5242880;
export const ALPHA_NUMERIC_REGEX = /^[a-zA-Z0-9]*$/;
export const ONLY_ALPHA_NUMERIC_REGEX = /^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d]+$/;
export const BULSTAT_LENGTH = 15;
export const LEADING_ZEROS_REGEX = /^0+/;
export const DEFAULT_CURRENCY = "EUR";

//All permissions
export const UserPermissions = {
    DashboardAllowed: "crm:dashboard:view",
    MerchantDashboardAllowed: "crm:merchantdashboard:view",
    MerchantDashboardUpdateAllowed: "crm:merchantdashboard:update",
    CRMUserAllAllowed: "crm:users:all",
    CRMUserAllowed: "crm:users:view",
    CRMUserCreateNewAllowed: "crm:users:create",
    UserProfileViewDetailsAllowed: "crm:users:viewdetails",
    UserPaymentMethodUpdateAllowed: "crm:users:payment-methods",
    MerchantAllAllowed: "crm:merchants:all",
    MerchantCreateNewAllowed: "crm:merchants:create",
    MerchantUpdateAllowed: "crm:merchants:update",
    MerchantPaymentMethodUpdateAllowed: "crm:merchants:payment-methods",
    IndividualPaymentMethodUpdateAllowed: "crm:individual:payment",
    IndividualDepositAllowed: "crm:individual:deposit",
    IndividualWithdrawAllowed: "crm:individual:withdraw",
    MerchantAllowed: "crm:merchants:view",
    MerchantClientsAllowed: "crm:merchant-clients:view",
    MerchantViewDetailAllowed: "crm:merchants:viewdetails",
    WalletsViewAllowed: "crm:wallets:view",
    WalletCreateAllowed: "crm:wallets:create",
    IbanCreateAllowed: "crm:iban:create",
    WalletCloseAllowed: "crm:wallets:close",
    TariffViewAllowed: "crm:tariff:view",
    TariffUpdateAllowed: "crm:tariff:update",
    KycSubmissionAllAllowed: "crm:kyc-submission:all",
    KycSubmissionViewAllowed: "crm:kyc-submission:view",
    KycSubmissionCreateAllowed: "crm:kyc-submission:create",
    KycDocumentAllAllowed: "crm:kyc-documents:all",
    JournalingAllowed: "crm:journaling:view",
    PortalAdminAllowed: "crm:portal:admin",
    CRMAllAllowed: "crm:all:all",
    OperatorsAndRolesAllAllowed: "crm:operators-and-roles:all",
    OperatorsAndRolesViewUserAllowed: "crm:operators-and-roles:view-user",
    OperatorsAndRolesCreateNewOperatorAllowed: "crm:operators-and-roles:create-new-operator",
    OperatorsAndRolesUpdateOperatorAllowed: "crm:operators-and-roles:update-operator",
    OperatorsAndRolesViewUsersRolesAllowed: "crm:operators-and-roles:view-user-roles",
    OperatorsAndRolesCreateNewRoleAllowed: "crm:operators-and-roles:create-new-role",
    OperatorsAndRolesUpdateRoleAllowed: "crm:operators-and-roles:update-role",
    OperatorsAndRolesDeleteRoleAllowed: "crm:operators-and-roles:delete-role",
    SftpDocumentCreateAllowed: "crm:sftp:create-document",
    SftpDocumentViewAllowed: "crm:sftp:view-document",
    MerchantTransactionsViewAllowed: "crm:merchant-transactions:view",
    IndividualTransactionViewAllowed: "crm:individual-transactions:view",
    IndividualDocumentsViewAllowed: "crm:individual-documents:view",
    IndividualDocumentsDownloadAllowed: "crm:individual-documents:download",
    IndividualDocumentsUploadAllowed: "crm:individual-documents:upload",
    IndividualDocumentsReviewAllowed: "crm:individual-documents:review",
    IndividualDocumentsApproveAllowed: "crm:individual-documents:approve",
    IndividualDocumentsManageInternalNoteAllowed: "crm:individual-documents:manage-internal-note",
    IndividualDocumentsManageCustomerVisibilityAllowed: "crm:individual-documents:manage-customer-visibility",
    OpenBankingViewUserAllowed: "crm:open-banking:view-user",
    OpenBankingViewTransactionAllowed: "crm:open-banking:view-transaction",
    OpenBankingViewWalletAllowed: "crm:open-banking:view-wallet",
    OpenBankingIbanTransferAllowed: "isOpenBankingIbanTransferAllowed",
    OperationsAllowed: "crm:operation:view",
    UserProfileUpdateAllowed: "crm:users:update",
    KYCAssessAllowed: "crm:kyc-submission:assess",
    KYCApproveAllowed: "crm:kyc-submission:approve",
    MerchantProfileUpdateAllowed: "crm:merchants:update",
    OperatorsUpdateAllowed: "crm:operators-and-roles:update-operator",
    MerchantsClientsViewAllowed: "crm:merchant-clients:view",
    MerchantsClientsCreateAllowed: "crm:merchant-clients:create",
    ConfidentialClientsViewAllowed: "crm:confidential-clients:view",
    ConfidentialClientsManageAllowed: "crm:confidential-clients:manage",
    ApiScopesViewAllowed: "crm:api-scopes:view",
    ApiScopesManageAllowed: "crm:api-scopes:manage",
    RollbackTransactionAllowed: "crm:rollback:transaction",
    LeadsPermissionAll: "crm:leads:all",
    MassPaymentExecutorAllowed: "crm:mass-payment-executor:all",
    canDeleteMerchant: "crm:merchants:update",
    BoricaTransactionsViewAllowed: "crm:borica-transactions:view",
    BoricaTransactionsUpdateAllowed: "crm:borica-transactions:update",
};


